import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconError = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 20 20" size={size}>
      <g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1">
        <g fill="currentColor" transform="translate(-2.000000, -212.000000)">
          <g transform="translate(2.000000, 212.000000)">
            <path d="M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 L10,0 Z M11,15 L9,15 L9,13 L11,13 L11,15 L11,15 Z M11,11 L9,11 L9,5 L11,5 L11,11 L11,11 Z" />
          </g>
        </g>
      </g>
    </BaseIcon>
  );
}

export default IconError;